import React, { Component, createRef } from "react";
import { withNamespaces } from "react-i18next";

import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-2.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";

import "component/list/Games/styles.scss";

class CommonGames extends Component {
  constructor(props) {
    super(props);
    this.endRef = createRef();
    this.state = {
      games: null,
      showMore: false,
    };
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (
                this.endRef.current &&
                (!this.props.isLoading && !this.props.isLoadingNext) &&
                this.props.hasNextPage &&
                this.props.fetchGames
              ) {
                this.props.fetchGames();
              }
            }
          });
        },
        {
          rootMargin: "0px 0px 0px 0px",
          threshold: 0.1,
        },
      );
      observer.observe(this.endRef.current);
    } else {
    }
  }

  componentDidMount() {
    this.initObserver();
  }

  componentWillUnmount() {
    this.props.componentWillUnmount();
  }

  render() {
    const { t } = this.props;
    let ItemComponent = this.props.itemComponent;

    return (
      <div className="common-games-list">
        <div className="row category-name">
          <div
            className={`col ${
              this.props.route.get("rel").indexOf("free.rounds-claim.rewards")
                ? ""
                : "highlight"
            } ${
              this.props.route.get("rel").indexOf("tournament-games")
                ? ""
                : "highlight"
            } ${
              this.props.route.get("rel").indexOf("jackpot-games")
                ? ""
                : "highlight"
            }
            `}
          >
            {this.props.route.get("name")}
          </div>
        </div>
        <div
          className={`row nopadding flex-row w-100 ${
            this.state.showMore ? "show-more" : ""
          }`}
        >
          {this.props.games &&
            this.props.games.get("items").map((item, key) => {
              let linkDemo = item.get("links").find((link) => {
                return link.get("rel") === "launch.demo";
              });
              let linkReal = item.get("links").find((link) => {
                return link.get("rel") === "launch.real";
              });
              let linkDetails = item.get("links").find((link) => {
                return link.get("rel") === "game.details";
              });
              return (
                <div className="col col-game col-item" key={key}>
                  <ItemComponent
                    game={item}
                    isMobile={this.props.isMobile}
                    linkDemo={linkDemo}
                    linkReal={linkReal}
                    linkDetails={linkDetails}
                    onClick={(playType) => {
                      if (linkReal && this.props.isOneClickPlayEnabled)
                        return this.props.onGameItemClickHandler({
                          game: item,
                          playType: linkReal.get("rel"),
                        });
                      if (linkDemo && this.props.isOneClickPlayEnabled)
                        return this.props.onGameItemClickHandler({
                          game: item,
                          playType: linkDemo.get("rel"),
                        });
                      return this.props.onGameItemClickHandler({
                        game: item,
                        playType,
                      });
                    }}
                    imageFormat={this.props.imageFormat}
                    latestBroadcast={this.props.latestBroadcast}
                    currency={this.props.currency}
                    isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
                    gameLimit={item.get("gameLimit")}
                  />
                </div>
              );
            })}
          <div
            className={`col col-end col-item nopadding ${
              this.props.isLoading ||
              (!this.props.isLoading && !this.props.isLoadingNext)
                ? ""
                : "d-none"
            } ${this.props.hasNextPage ? "" : "d-none"}`}
            ref={this.endRef}
          >
            <ItemComponent />
          </div>
          {!this.props.games ||
            this.props.isLoading ||
            (this.props.isLoadingNext &&
              [...Array(3)].map((item, key) => {
                return (
                  <div className="col col-item nopadding" key={key}>
                    <ItemComponent isMobile={this.props.isMobile} />
                  </div>
                );
              }))}
        </div>
        {this.props.games && this.props.games.get("items").size > 4 && (
          <div className="show-more text-center d-none">
            <button
              className="btn btn-dark btn-sm"
              onClick={() => {
                this.setState({
                  showMore: !this.state.showMore,
                });
              }}
            >
              {this.state.showMore ? t("showLess") : t("showMore")}
              {this.state.showMore ? <ArrowUp /> : <ArrowDown />}
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default withNamespaces("translation")(CommonGames);
